var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loginTypes && _vm.loginTypes.length > 1)?_c('el-tabs',{on:{"tab-click":_vm.loginTypeClick},model:{value:(_vm.loginType),callback:function ($$v) {_vm.loginType=$$v},expression:"loginType"}},_vm._l((_vm.loginTypes),function(lgt){return _c('el-tab-pane',{key:lgt.value,attrs:{"label":lgt.label,"name":lgt.value}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }